import angular from 'angular';
import 'intl-tel-input';

angular
  .module('cloudX')
  .constant('ipnConfig', {
    allowExtensions: false,
    autoFormat: true,
    autoHideDialCode: true,
    autoPlaceholder: true,
    customPlaceholder: null,
    defaultCountry: '',
    geoIpLookup: null,
    nationalMode: true,
    numberType: 'MOBILE',
    onlyCountries: [],
    preferredCountries: ['us', 'gb'],
    skipUtilScriptDownload: true,
    utilsScript: '',
  })
  .directive('internationalPhoneNumber', [
    '$timeout',
    'ipnConfig',
    function($timeout, ipnConfig) {
      return {
        restrict: 'A',
        require: ['^ngModel', '^?bindErrors'],
        scope: {
          ngModel: '=',
          country: '=',
        },
        link: function(scope, element, attrs, ctrls) {
          var options = angular.copy(ipnConfig);
          angular.forEach(options, function(value, key) {
            if (!(attrs.hasOwnProperty(key) && angular.isDefined(attrs[key]))) return null;
            var option = attrs[key];

            if (key === 'preferredCountries') {
              return (options.preferredCountries = handleWhatsSupposedToBeAnArray(option));
            } else if (key === 'onlyCountries') {
              return (options.onlyCountries = handleWhatsSupposedToBeAnArray(option));
            } else if (typeof value === 'boolean') {
              return (options[key] = option === 'true');
            } else {
              return (options[key] = option);
            }
          });

          var intlOptions = {
            ...options,
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.0/js/utils.js',
          };

          // initialise plugin
          var telInputPlugin = window.intlTelInput(element[0], intlOptions);

          var ctrl = ctrls[0];

          var bindErrors = ctrls[1];
          var read = function() {
            return ctrl.$setViewValue(telInputPlugin.getNumber(1));
            //return ctrl.$setViewValue(element.val());
          };
          var handleWhatsSupposedToBeAnArray = function(value) {
            if (value instanceof Array) {
              return value;
            } else {
              return value
                .toString()
                .replace(/[ ]/g, '')
                .split(',');
            }
          };

          ctrl.$render = function() {
            if (
              ctrl.$modelValue !== null &&
              ctrl.$modelValue !== void 0 &&
              ctrl.$modelValue.length > 0
            )
              telInputPlugin.setNumber(ctrl.$modelValue);
            else element.val('');
          };

          scope.$watch('country', function(newValue) {
            if (newValue !== null && newValue !== void 0 && newValue !== '') {
              return telInputPlugin.setCountry(newValue);
            }
          });
          ctrl.$formatters.push(function(value) {
            if (!value) {
              return value;
            }
            return telInputPlugin.getNumber(1);
          });
          ctrl.$parsers.push(function(value) {
            if (!value) {
              return value;
            }
            var selectedCountry = telInputPlugin.getSelectedCountryData();
            if (!selectedCountry || value.indexOf('+' + selectedCountry.dialCode) !== 0)
              return telInputPlugin.getNumber(1); //1 international
            return value;
          });
          ctrl.$validators.internationalPhoneNumber = function(value) {
            var selectedCountry = telInputPlugin.getSelectedCountryData();
            if (!value || (selectedCountry && '+' + selectedCountry.dialCode === value)) {
              return true;
            }

            return telInputPlugin.isValidNumber();
          };
          if (bindErrors) {
            bindErrors.addError('internationalPhoneNumber', 'msgInvalidPhoneNumber');
            ctrl.$viewChangeListeners.push(function() {
              bindErrors.refreshErrors(ctrl.$error);
            });
            scope.$on('$destroy', function() {
              bindErrors.refreshErrors();
            });
          }
          element.on('blur keyup change countrychange', function() {
            return $timeout(read, 100);
          });

          return element.on('$destroy', function() {
            telInputPlugin.destroy();
            return element.off('blur keyup change countrychange');
          });
        },
      };
    },
  ]);
